import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { VALIDATE_EMAIL } from './constants';

export const validateEmail = extendRoutine(createRoutine(VALIDATE_EMAIL), ['RESET']);
